import React from 'react'

import {
    Card,
    FormBox,
    LoginButton,
    Logo,
    LogoBlock,
    LogoRow,
    LogoText,
    Subtitle,
} from '../style'
import { useHomeLogin } from './useHomeLogin'

const HomeLogin = () => {
    const { handleLogin } = useHomeLogin()

    return (
        <Card>
            <LogoBlock>
                <LogoRow>
                    <Logo src="/images/guap-sign.svg" alt="ГУАП" />
                    <LogoText>ГУАП</LogoText>
                </LogoRow>
                <Subtitle>Редактор расписания</Subtitle>
            </LogoBlock>

            <FormBox>
                <LoginButton type="button" onClick={handleLogin}>
                    Войти через единую точку авторизации ГУАП
                </LoginButton>
            </FormBox>
        </Card>
    )
}

export default HomeLogin
